import { useEffect, useRef, useState } from 'react'
import DatePicker from 'react-datepicker'
import './MDatePicker.css'
import { cn } from '@/utlis/cn'

const MDatePicker: React.FC<{
    className?: string
    date: Date
    closerClickEv?: React.MouseEvent<HTMLDivElement, MouseEvent>
    onChange: (date: Date) => void
}> = ({ className = '', date, closerClickEv, onChange }) => {
    const [isOpen, setIsOpen] = useState(false)

    const containerRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        if (!closerClickEv) {
            return
        }
        try {
            // @ts-ignore
            if (containerRef.current && containerRef.current.contains(closerClickEv.target)) {
                // no-op
            } else {
                setIsOpen(false)
            }
        } catch (e) {
            /* exception expected in certain cases */
        }
    }, [closerClickEv])

    return (
        <div className={cn('flex items-center', 'm-date-picker-wrapper', className)} ref={containerRef}>
            <DatePicker
                showIcon
                className="m-date-picker-custom"
                selected={date}
                onChange={(date) => {
                    if (date) {
                        onChange(date)
                    }
                    setIsOpen(false)
                }}
                open={isOpen}
                onInputClick={() => {
                    setIsOpen(true)
                }}
            />
        </div>
    )
}

export default MDatePicker
